// export * from 'fast-safe-stringify';
import raw from 'fast-safe-stringify';

// @ts-ignore
const stringify = raw.default;

export { stringify };
export default stringify;

// export { default as stringify } from 'fast-safe-stringify';
// export { default } from 'fast-safe-stringify';
